import { Chip } from "@kirvanobr/chip";
import { Typography } from "@kirvanobr/typography";
import { Spacer } from "@kirvanobr/spacer";
import { styles } from "./TabContentHeader.styles";
import { TabContentHeaderProps } from "./TabContentHeader.types";
import { Skeleton } from "@kirvanobr/skeleton";

export const TabContentHeader = ({
  children,
  title,
  subtitle,
  itemsAmount,
  actionComponent,
  hasNewItems,
  isLoading,
}: TabContentHeaderProps) => {
  return (
    <div className={styles().base()}>
      <div className={styles().topComponentsWrapper()}>
        <div className={styles().titleWrapper()}>
          <div className={styles().title()}>
            <Typography as="h1" variant="title" size="t5" weight="bold">
              {title}
            </Typography>
            {isLoading && <Skeleton radius="full" width={24} height={24} />}
            {itemsAmount != undefined && itemsAmount >= "0" && !isLoading && (
              <Chip
                color="default"
                classNames={{
                  base: `h-6 min-w-6 grid items-center justify-center ${
                    hasNewItems ? "bg-warningO-400 text-white" : "bg-foreground-200"
                  }`,
                  content: "text-[0.625rem] font-extrabold p-0",
                }}
              >
                {itemsAmount}
              </Chip>
            )}
          </div>
          <Typography variant="body" size="t3">
            {subtitle}
          </Typography>
          <Spacer y={0} />
        </div>
        {actionComponent && <div className={styles().actionComponentWrapper()}>{actionComponent}</div>}
      </div>

      <div className={styles().childrenWrapper()}>{children}</div>
    </div>
  );
};
